import { gray20, gray45, gray70 } from '../../../colors/gray';
import { rem } from '../../../utils/rem';
export var MuiAvatar = {
    styleOverrides: {
        colorDefault: {
            border: "".concat(rem(1), " solid ").concat(gray45),
            backgroundColor: gray70,
            color: gray20,
        },
    },
};
